import WhiteNavbar from "components/Navbars/WhiteNavbar";
import React from "react";
import { Helmet } from "react-helmet-async";
import Footer from "components/Footers/Footer";
import "../assets/css/LawyerList.css";
import lawyers from "../assets/avukatlar/Avukatlar.json";

const Lawyer = () => {
  function LawyerCard({ item, index }) {
    return (
      <article
        className={`ll-card cursor-pointer in`}
        style={{ "--stg": `${index * 60}ms` }}
        onClick={() => {
          window.open(
            `/ekibimiz/${item?.url}`,
            "_blank",
            "noopener,noreferrer"
          );
        }}
      >
        <div
          className="ll-bg"
          style={{ backgroundImage: `url(${item.img})` }}
          aria-hidden="true"
        />

        <div className="ll-social">
          <a
            href={
              item.linkedin && item.linkedin !== ""
                ? item.linkedin
                : "https://www.linkedin.com/company/ek%C5%9Fio%C4%9Flu-hukuk-dan%C4%B1%C5%9Fmanl%C4%B1k/?viewAsMember=true"
            }
            target="_blank"
            aria-label="Linkedin"
            title="Linkedin"
            onClick={(e) => e.stopPropagation()}
            rel="noreferrer"
          >
            <i className="fab fa-linkedin" />
          </a>
          <a
            href="https://www.instagram.com/eksiogluhukukvedanismanlik/"
            target="_blank"
            aria-label="Instagram"
            title="Instagram"
            onClick={(e) => e.stopPropagation()}
            rel="noreferrer"
          >
            <i className="fab fa-instagram" />
          </a>
          <a
            href={`/ekibimiz/${item.url}`}
            target="_blank"
            aria-label="Detaylar"
            title="Detayları Gör"
            onClick={(e) => e.stopPropagation()}
            rel="noreferrer"
          >
            <i className="fa-solid fa-arrow-up-right-from-square" />
          </a>
        </div>

        <div className="ll-content font-sans">
          <h3 className="ll-name">{item.name}</h3>
          <div className="ll-divider"></div>
          <p className="ll-title">{item.title}</p>
        </div>
      </article>
    );
  }

  return (
    <>
      <Helmet>
        <title>YÖNETİM KADROMUZ | EKŞİOĞLU HUKUK</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Ekşioğlu Hukuk Ofisi hakkında detaylı bilgi edinin. Hukuki hizmetlerimiz ve uzman kadromuzla size en iyi danışmanlık hizmetini sunuyoruz."
        />
        <link
          rel="canonical"
          href="https://www.eksiogluhukukofisi.com/ekibimiz"
        />
        <meta property="og:title" content="YÖNETİM KADROMUZ | EKŞİOĞLU HUKUK" />
        <meta property="og:type" content="website" />
        <meta property="og:description" content="EKŞİOĞLU HUKUK" />
        <meta
          property="og:image"
          content="https://www.eksiogluhukukofisi.com/static/media/eksiogluWhiteLogo.e14b5e9c41e5271d670c.png"
        />
        <meta
          property="og:url"
          content="https://www.eksiogluhukukofisi.com/ekibimiz"
        />
      </Helmet>

      <WhiteNavbar navbarSelection={"about-us"} />

      <div className="text-[35px] font-bold mt-[120px] mb-5 font-sans text-center">
        YÖNETİM KADROMUZ
      </div>

      <section className="ll-wrap">
        <div className="ll-grid">
          {lawyers?.map((item, i) => (
            <LawyerCard key={item.name + i} item={item} index={i} />
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Lawyer;
